import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { arrayOf, bool, element, func, node, number, oneOf, shape, string } from 'prop-types';
import { VARIANT } from "./constants";
var variant = oneOf(Object.keys(VARIANT));
export var menuItemPropType = shape({
  iconEnd: element,
  iconStart: element,
  disabled: bool,
  divider: bool,
  onClick: func,
  render: func,
  secondaryText: node,
  text: node,
  title: node,
  value: string,
  variant: variant
});
export var menuItemsPropType = arrayOf(menuItemPropType);
export var menuPropTypes = {
  children: node,
  data: menuItemsPropType,
  highlightedIndex: number,
  item: func,
  itemKey: string
};
export var menuDividerPropTypes = {};
export var menuGroupPropTypes = {
  children: node,
  title: node
};
export var menuItemPropTypes = {
  children: node,
  disabled: bool,
  iconEnd: element,
  iconStart: element,
  index: number,
  isHighlighted: bool,
  item: menuItemPropType,
  onClick: func,
  render: func,
  secondaryText: node,
  variant: variant
};